(function() {
  'use strict';

  var faqList = document.querySelectorAll('.js-faqlist:not(.editmode)');
  var schadeDetail = document.querySelectorAll('.schadedetail');

  if (faqList.length && schadeDetail.length === 0) {
    window.addEventListener('load', function() {
      var targetElement = document.querySelector(':target');
      if (targetElement && targetElement.classList.contains('flii__question')) {
        targetElement.parentElement?.parentElement?.setAttribute('open', '');
      }
    });
  }
})();
